import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSvg = styled.svg.withConfig({
  displayName: "ArrowRightIcon__StyledSvg",
  componentId: "thri7r-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    maxHeight: '10px',
    fill: theme.color['icon-primary-default'],
    width: '6px',
    position: 'absolute',
    right: '18px',
    top: '50%',
    transform: 'translateY(-50%)'
  };
});
const ArrowRightIcon = () => /*#__PURE__*/_jsx(StyledSvg, {
  viewBox: "0 0 13 24",
  children: /*#__PURE__*/_jsx("path", {
    d: "M12.88 11.44a1.48 1.48 0 00-.16-.25l-.09-.19a.35.35 0 000-.07L2.63.43a1.528 1.528 0 10-2.22 2.1l9 9.46-9 9.47a1.5 1.5 0 002.17 2.07l10-10.5a.36.36 0 000-.07l.1-.15a1.47 1.47 0 00.16-.25 1.44 1.44 0 00.06-.28A1.49 1.49 0 0013 12a1.49 1.49 0 000-.28 1.42 1.42 0 00-.06-.28"
  })
});
export default ArrowRightIcon;